import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable()
export class RateSyncChannelService {

  constructor(
    private http: HttpClient,
  ) { }

 // private baseEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/"
 // private RateEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/"

   private baseEndPoint: string = "https://fxdhdashboardapi.idsnext.live/"
  private RateEndPoint: string = "https://fxdhdashboardapi.idsnext.live/"
/*  private baseEndPoint: string = "https://idsdatahubdashboardapinew.azurewebsites.net/"
  private RateEndPoint: string = "https://idsdatahubdashboardapinew.azurewebsites.net/" */

  getCMLIST(PMSCUSTCODE: any) {
    let data = { 'pmscode': PMSCUSTCODE };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    
    let endPoint = this.baseEndPoint + "api/AllCmLog/IsAllCmLog";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getROOMLIST(PMSCUSTCODE: any) {
    let data = { 'pmscode': PMSCUSTCODE };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    
    let endPoint = this.baseEndPoint + "api/AllCmLog/GetRoomType";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  GetRateReportChannel(SOURCE:any,PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any,SearchRateCode:any,echoToken:any, PGF: any, PGT: any) {
    let data = { 'source':SOURCE,'pmscode': PMSCUSTCODE,'fromdate': selectedDate, 'todate': selectedTOODate,"RATECODE":SearchRateCode,"ECHOTOKEN":echoToken, 'PaginationFromId': PGF, 'PaginationToId': PGT };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.baseEndPoint + "api/RateSync/GetChannelAndFortune"; // To insert API URL here
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getRateToChannelXML(PMSCUSTCODE: any, selectedChannel:any,Type:any,TOKEN:any,Source:any)
    {
      let data = { 'pmscode': PMSCUSTCODE, 'cmcode': selectedChannel,'xchangeformat':Type,'token':TOKEN,'Source':Source};
        let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
          let endPoint = this.RateEndPoint + "api/AriXml/NewRateXml";
        return this.http.post(endPoint,  data , { headers: headers })
          .map((response: Response) => JSON.parse(JSON.stringify(response)));
     }
  
}
